import { render, staticRenderFns } from "./Bak.vue?vue&type=template&id=4e8640b3"
import script from "./Bak.vue?vue&type=script&lang=js"
export * from "./Bak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports